import {
  AndCondition,
  Condition,
  LeafCondition,
  OrCondition,
  RuleEffect,
  SchemaBasedCondition,
  Scopable,
  UISchemaElement,
  composeWithUi,
  resolveData,
} from '@jsonforms/core';
import has from 'lodash/has';
import type Ajv from 'ajv';

const isOrCondition = (condition: Condition): condition is OrCondition => condition.type === 'OR';

const isAndCondition = (condition: Condition): condition is AndCondition => condition.type === 'AND';

const isLeafCondition = (condition: Condition): condition is LeafCondition => condition.type === 'LEAF';

const isSchemaCondition = (condition: Condition): condition is SchemaBasedCondition => has(condition, 'schema');

const getConditionScope = (condition: Scopable, path: string): string => {
  return composeWithUi(condition, path);
};

const evaluateCondition = (data: any, condition: Condition, path: string, ajv: Ajv): boolean => {
  if (isAndCondition(condition)) {
    return condition.conditions.reduce((acc, cur) => acc && evaluateCondition(data, cur, path, ajv), true);
  } else if (isOrCondition(condition)) {
    return condition.conditions.reduce((acc, cur) => acc || evaluateCondition(data, cur, path, ajv), false);
  } else if (isLeafCondition(condition)) {
    const value = resolveData(data, getConditionScope(condition, path));
    return value === condition.expectedValue;
  } else if (isSchemaCondition(condition)) {
    const value = resolveData(data, getConditionScope(condition, path));
    if (condition.failWhenUndefined && value === undefined) {
      return false;
    }
    return ajv.validate(condition.schema, value) as boolean;
  } else {
    // unknown condition
    return true;
  }
};

const isRuleFulfilled = (uischema: any, data: any, path: string, ajv: Ajv): boolean => {
  const condition = uischema.rule.condition;
  return evaluateCondition(data, condition, path, ajv);
};

// export const evalVisibility = (uischema: any, data: any, path: any = undefined, ajv: Ajv): boolean => {
//   const fulfilled = isRuleFulfilled(uischema, data, path, ajv);

//   switch (uischema.rule.effect) {
//     case RuleEffect.HIDE:
//       return !fulfilled;
//     case RuleEffect.SHOW:
//       return fulfilled;
//     case 'NEXT':
//       return fulfilled;
//     // visible by default
//     default:
//       return true;
//   }
// };

export const checkNextStep = (uischema: any, data: any, path: any = undefined, ajv: Ajv): boolean => {
  if (uischema.rule && uischema.rule.effect === 'NEXT') {
    return isRuleFulfilled(uischema, data, path, ajv);
  }

  return false;
};
